export const data = () => ({
  isDebug: true,
  loading: false,
  workOrderRequestID: 0,
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
